// extracted by mini-css-extract-plugin
export default {"Avatar":"Avatars_Avatar__pkmua","charachter":"Avatars_charachter__3ldML"};